module.exports = __webpack_public_path__ + "img/um.1fe0828c.svg";